import React, { useEffect, useState, ChangeEvent} from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { stateHasValue } from '../../../helpers/stateHasValue';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Input } from '../../Common/Input';
import { SelectedIcon } from '../../Common/Selector';
// import { SectionContent } from './SectionContent';

const StyledInputWrapper = styled.div`
  position: relative;
  margin: 1rem 0.5rem;
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 300px;
`;

export const RoomName = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    custom: { roomName },
  } = state.context;
  const [tempRoomName, setTempRoomName] = useState(roomName || '');

  useEffect(() => {
    setTempRoomName(roomName || '');
  }, [roomName]);

  return (
    <Wrapper>
      <Heading>Room name</Heading>
      <Caption>
        Add a room name to easily identify each product as it arrives.
      </Caption>
      <StyledInputWrapper>
        {/* {stateHasValue(state) && <SelectedIcon />} */}
        <Input
          id="room-name"
          value={tempRoomName}
          placeholder="Room Name"
          onChange={(event: ChangeEvent<{ value: string }>) => {
            setTempRoomName(event.target.value);
          }}
          onBlur={(event: ChangeEvent<{ value: string }>) => {
            send({
              type: 'UPDATE_CUSTOM',
              custom: {
                roomName: event.target.value,
              },
            });
          }}
        />
      </StyledInputWrapper>
    </Wrapper>
  );
};
